import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const useDeleteApiKeyMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: unknown) => void;
  } = { onSuccess: () => {} }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const deletePromise = client.delete(`/auth/keys/${id}`);

      const { data } = await toast.promise(deletePromise, {
        loading: 'Deleting API key...',
        success: 'API key deleted successfully',
        error: (error) => {
          if (axios.isAxiosError(error)) {
            return error?.response?.data?.message || 'Failed to delete API key';
          }
          return error instanceof Error ? error.message : 'Failed to delete API key';
        },
      });

      return data.body;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['auth', 'keys'],
      });
    },
  });
};
